import { call, put } from 'redux-saga/effects';
import {
  fetchBillingDetailsFailure,
  fetchBillingDetailsSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { FetchBillingDetailsRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { GetBillingDetailsResponse, getBillingDetails } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { renderErrorMessage } from 'utils/render-error-message';
import { BillingFormRequest } from '../models/billingFormRequest';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* getBillingDetailsSaga(
  action: FetchBillingDetailsRequestAction
) {
  try {
    let err: ApiError | null;
    const { accountId } = action.payload;

    const getBillingDetailsResponse: GetBillingDetailsResponse = yield call(
      getBillingDetails,
      accountId
    );

    err = checkResponse(getBillingDetailsResponse?.responseMessage);
    if (err) throw err;
    const billingDetails: BillingFormRequest = getBillingDetailsResponse.data;
    yield put(fetchBillingDetailsSuccess(billingDetails));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    }
    yield put(fetchBillingDetailsFailure());
  }
}
